export const FRIEND_STATUS = {
    R: "requested",
    A: "accepted",
    D: "declined",
    B: "blocked"
}